<template>
  <div class="dropdown">
    <button class="dropdown-btn" @click="openMenu" @mouseleave="closeMenu">
      <figure class="profile-wrapper">
        <img :src="getProfilePicture" alt="" />
      </figure>
    </button>
    <div
      class="dropdown-content"
      :class="{ open: open }"
      @mouseover="openMenu"
      @mouseleave="closeMenu"
    >
      <div class="option" @click="goToProfile">Profile</div>
      <div class="option" @click="logout">Logout</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "ProfileDropdown",
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters({
      getProfilePicture: "auth/getProfilePicture",
    }),
  },
  methods: {
    openMenu() {
      this.open = true;
    },
    closeMenu() {
      this.open = false;
    },
    goToProfile() {
      this.$router.push("/profile");
    },
    logout() {
      this.open = false;
      store.commit("loading/startLoading");
      store.commit("logout");
      this.$store.dispatch("auth/logout");
      this.$store.dispatch("onboard/clearOnboardInfo");
      this.trackEvent("Auth", "Logout");
      setTimeout(() => {
        store.commit("loading/stopLoading");
        this.$router.replace("/");
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  pointer-events: all;
  .dropdown-btn {
    background-color: rgba(0, 0, 0, 0.1);
    border: 0;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    height: 36px;
    width: 36px;
    margin-inline-start: 4px;
    padding: 2px;
    position: relative;
    pointer-events: auto;
    &:hover {
      background-color: rgba(0, 0, 0, 0);
      transition: all 0.2s ease-in;
    }
    .profile-wrapper {
      width: 100%;
      height: 100%;
      display: inline-block;
      position: relative;
      img {
        border-radius: 50%;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
  }

  .dropdown-content {
    display: none;
    position: absolute;
    right: 0;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    cursor: pointer;
    &.open {
      display: block;
    }
    .option {
      color: #444;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: normal;
      line-height: 16px;
      text-transform: none;
      &:hover {
        background-color: #f1f1f1;
        color: black;
      }
    }
  }
}
</style>
